module.exports = __webpack_public_path__ + "media/images/bg/mosaic/cloud-lightblue-cf2a570e9b42145ba3a4b65599d1df0c.svg";